// extracted by mini-css-extract-plugin
module.exports = {"home":"index_home__3RGC8","form_wrapper":"index_form_wrapper__1of_S","button":"index_button__a6h9_"};